import { useEffect } from 'react'
import { Stack } from '@mui/material'
import { useToggle } from 'usehooks-ts'
import { MyInviter } from './components/my-inviter/my-inviter'
import { InvitationStatusBar } from './components/invitation-status-bar'
import { InviteActionBox } from './components/invite-action-box'
import { InvitationUsersInfo } from './components/invitation-users-info'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { closeInviteFriends } from '$logic/router'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { getInvitations } from '$logic/invite/service'
import { t } from '$i18n'
import { nothing } from '$helper/functions/utils'

export const inviteApi = {
  updateInviteList: nothing,
}

export function Invite() {
  const [triggerGetInvitationsState, triggerGetInvitations] = useToggle(false)

  const {
    loading,
    value: invitations,
    error,
  } = useAsyncFunction(getInvitations, [triggerGetInvitationsState])

  const { invitationLimit = 0, invitationCount = 0 } = invitations || {}

  useEffect(() => {
    inviteApi.updateInviteList = () => {
      triggerGetInvitations()
    }
    return () => {
      inviteApi.updateInviteList = nothing
    }
  }, [])

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitle
          title={t('myAccount.inviteFriends')}
          onBack={closeInviteFriends}
        />
      }
    >
      <Stack
        overflow="hidden"
        paddingBottom="31px"
        position="relative"
        height="100%"
      >
        <InviteActionBox limit={invitationLimit - invitationCount} />
        <MyInviter />
        {!loading && invitationCount > 0 && (
          <InvitationUsersInfo
            invitations={invitations!}
            loading={Boolean(loading || error)}
          />
        )}

        <InvitationStatusBar
          invited={invitationCount}
          limit={invitationLimit}
          loading={Boolean(loading || error)}
        />
      </Stack>
    </PageWithAppBar>
  )
}
